export default __webpack_public_path__ + "static/media/Women_en.e1ec57d1.svg";